import React, {useEffect, useState, useCallback, useRef} from "react";
import "./style.scss";
import TabsMenu from "../../components/TabsMenu";
import moment from "moment";
import "moment-timezone";
import {
  createDropdownCompatibleServiceData,
  createDropdownCompatibleData,
} from "../../util";
import {API, processApiResponse} from "../../services/HttpHandler";
import {useNavigate} from "react-router-dom";
import Button from "../../components/Button";
import Loader from "../../components/Loader";
import {useTranslation} from "react-i18next";
import {
  checkContentAvlInArray,
  //  dataDashboard
} from "../../util";
import {MIN_ALLOWED_PEOPLE, ADOBEDTM_PAGE_NAME} from "../../constants";
import {showTimeRange, getCalendarDate} from "../../services/Format/Date";
import {
  setCustomerSlotDetails,
  getCustomerSlotDetails,
} from "../../services/SessionStorage";
import BlockBtn from "../../components/BlockBtn";
import {StepperWrapper} from "../../components/StepperWrapper";
import Dropdown from "../../components/Dropdown/Dropdown";
import CustomDatePicker from "../../components/CustomDatePicker/CustomDatePicker";
import config from "config";

const BookSlot = () => {
  const [loading, setLoading] = useState(false);
  let customerSlotDetails = getCustomerSlotDetails();
  const sessionCurrentBookingDetails =
    customerSlotDetails.currentBookingDetails;
  const sessionSelectedStore = sessionCurrentBookingDetails.selectedStore;
  const sessionServiceTypes = createDropdownCompatibleServiceData(
    sessionSelectedStore.serviceTypes
  );
  const storetimezone = sessionSelectedStore.timeZone;
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [noSlots, setNoSlots] = useState(false);
  const [peopleAllowedList, setpeopleAllowedList] = useState([]);
  const [disableDateList, setDisableDateList] = useState([]);
  const [numberOfPeople, setNumberOfPeople] = useState(peopleAllowedList[0]);
  const [pickUpDate, setPickUpDate] = useState(new Date());
  const [selectedServiceTypes, setSelectedServiceTypes] = useState(
    sessionServiceTypes[0]
  );
  const [slots, setSlots] = useState([]);
  const [masterslots, setmasterSlots] = useState([]);
  const [currentDaySlots, setCurrentDaySlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState("");
  const [lastSlotDate, setLastSlotDate] = useState(new Date());
  const [dayOptions, setDayOptions] = useState();
  const showNoonSlot = useRef(false);
  const getLastSlotDate = useCallback(
    (slots) => {
      let lastDate = lastSlotDate;
      slots.forEach((s) => {
        if (moment(s.startTime).isAfter(lastDate)) {
          lastDate = moment(s.startTime);
        }
      });
      return lastDate;
    },
    [lastSlotDate]
  );

  const getMaxAllowedPeopleCount = () => {
    let count = 1;
    if (selectedSlot?.value) {
      const allowedMax =
        selectedSlot.value.capacity - selectedSlot.value.reservedCapacity;
      count =
        allowedMax >= selectedSlot.value.noOfPeopleAllowedMax
          ? selectedSlot.value.noOfPeopleAllowedMax
          : allowedMax;
    }
    return count;
  };

  const createPeopleAllowedCount = () => {
    const lastAllowedValue = getMaxAllowedPeopleCount();
    let countArray = [];
    for (let tmpVal = 1; tmpVal <= lastAllowedValue; tmpVal++) {
      countArray.push(tmpVal);
    }
    setpeopleAllowedList(createDropdownCompatibleData(countArray));
    setNumberOfPeople(peopleAllowedList[0]);
  };

  const getMinAllowedPeopleCount = () => {
    return selectedSlot?.value
      ? selectedSlot.value.noOfPeopleAllowedDefault
      : MIN_ALLOWED_PEOPLE;
  };

  const getNoSlotText = () => {
    if (customerSlotDetails.isOffice) {
      return t("bookslot.officeNoSlotsText");
    } else if (customerSlotDetails.mallname === null) {
      return t("bookslot.storeNoSlotsText");
    } else {
      return t("bookslot.mallNoSlotsText");
    }
  };

  const filterSameDateSlots = (slots, currentDate) => {
    return slots.filter((slot) => {
      const currDate = moment
        .tz(currentDate, storetimezone)
        .format("YYYY-MM-DD");
      const slotDate = moment
        .tz(slot.startTime, storetimezone)
        .format("YYYY-MM-DD");
      return currDate === slotDate;
    });
  };

  const findEmptySlotsDates = () => {
    const endDate = getLastSlotDate(slots);
    const date = new Date();
    const availabledates = [];
    const slotdates = [];

    while (date < endDate) {
      availabledates.push(
        moment.tz(new Date(date), storetimezone).format("DD-MM-YYYY")
      );
      date.setDate(date.getDate() + 1);
    }

    for (let i = 0; i < slots.length; i++) {
      const dateTocheck = moment
        .tz(slots[i].startTime, storetimezone)
        .format("DD-MM-YYYY");
      if (slotdates.indexOf(dateTocheck) === -1) {
        slotdates.push(dateTocheck);
      }
    }

    var excludedates = availabledates.filter(
      (item) => slotdates.indexOf(item) === -1
    );

    return excludedates;
  };

  const onSlotBooking = async () => {
    bookSlotDetails();
  };

  const bookSlotDetails = () => {
    let selectedServiceTypeName = [];
    selectedServiceTypeName.push(
      sessionServiceTypes.find(
        (list) => list.uuid === selectedServiceTypes.uuid
      ).serviceType
    );
    const selectedSlotDetails = {
      endTime: selectedSlot.value.endTime,
      noOfPeople: numberOfPeople.value,
      serviceTypes: selectedServiceTypeName,
      slotId: selectedSlot.value.uuid,
      startTime: selectedSlot.value.startTime,
    };
    sessionCurrentBookingDetails.selectedSlot = selectedSlotDetails;
    customerSlotDetails.currentBookingDetails = sessionCurrentBookingDetails;
    customerSlotDetails.acceptTermsConditions = false;
    customerSlotDetails.showlimited = false;

    // const datamap = new Map();
    // datamap.set("eVar4", selectedServiceTypeName);
    // datamap.set("eVar10", numberOfPeople);
    // datamap.set("eVar26", pickUpDate);
    // datamap.set(
    //   "eVar27",
    //   selectedSlot.value.startTime + " - " + selectedSlot.value.endTime
    // );
    // dataDashboard(datamap);
    setCustomerSlotDetails(customerSlotDetails);
    navigate("/customer/confirmBooking", {replace: true});
  };

  const handleBackBtn = () => {
    if (
      checkContentAvlInArray(
        config.stand_alone_bu_list,
        customerSlotDetails.buList
      )
    ) {
      navigate("/customer/selectMallStore");
    } else {
      navigate("/customer/selectStore");
    }
  };

  const isBanco = () => {
    if (customerSlotDetails.source.includes("bancofalabella")) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    setLoading(true);
    API.get(config.endPoints.slots + `?storeid=${sessionSelectedStore.uuid}`)
      .then(processApiResponse)
      .then(
        (s) => {
          if (s && s.length > 0) {
            setmasterSlots(s);
          } else {
            setNoSlots(true);
          }
          setLoading(false);
        },
        (err) => {
          setNoSlots(true);
          setLoading(false);
        }
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionSelectedStore.uuid]);

  useEffect(() => {
    setDisableDateList(findEmptySlotsDates());
    if (sessionCurrentBookingDetails.bu?.label === config.showNoonSlotsBU) {
      showNoonSlot.current = true;
    } else {
      showNoonSlot.current = false;
    }
    const filterSameDate = filterSameDateSlots(
      slots,
      getCalendarDate(pickUpDate)
    );
    setCurrentDaySlots(filterSameDate);
    let dayOptions = [];
    if (filterSameDate.length === 1) {
      dayOptions = [{label: "Jornada Completa", value: filterSameDate[0]}];
    } else {
      if (isBanco()) {
        dayOptions = filterSameDate.map((option) => {
          const data = showTimeRange(option.startTime, "", storetimezone);
          return {label: data, value: option};
        });
      } else {
        dayOptions = filterSameDate.map((option) => {
          const data = showTimeRange(
            option.startTime,
            option.endTime,
            storetimezone
          );
          return {label: data, value: option};
        });
      }
    }
    setSelectedSlot(dayOptions[0]);
    setDayOptions(dayOptions);
    createPeopleAllowedCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickUpDate, slots]);
  useEffect(() => {
    if (customerSlotDetails.isOffice && !selectedSlot?.value) {
      setSelectedSlot(
        currentDaySlots && currentDaySlots[0] ? currentDaySlots[0] : ""
      );
      createPeopleAllowedCount();
    }
  }, [currentDaySlots, customerSlotDetails.isOffice]);

  useEffect(() => {
    if (selectedSlot) {
      createPeopleAllowedCount();
    }
  }, [selectedSlot]);

  useEffect(() => {
    if (masterslots.length) {
      for (let i = 0; i < masterslots.length; i++) {
        if (masterslots[i].serviceTypeId === selectedServiceTypes.uuid) {
          setSlots(masterslots[i].slots);
          const date = getLastSlotDate(masterslots[i].slots);
          setLastSlotDate(new Date(date.toISOString()));
          return;
        } else {
          setSlots([]);
          setLastSlotDate(new Date());
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [masterslots, selectedServiceTypes]);

  // useEffect(() => {
  //   // for data dashboard
  //   const URL = window.location.href.split("/")[2];
  //   const officeApp = customerSlotDetails.isOffice
  //     ? URL + "/office"
  //     : URL + "/app";
  //   const datamap = new Map();
  //   datamap.set("pageName", ADOBEDTM_PAGE_NAME.CT_Service_and_Slot_Selection);
  //   datamap.set("prop1", URL);
  //   datamap.set("prop2", officeApp);
  //   dataDashboard(datamap);
  // }, []);

  return loading ? (
    <div className="loader-container">
      <Loader />
    </div>
  ) : (
    <div className="book-slot-contents-wrap">
      <TabsMenu path="bookSlot" />
      {!noSlots ? (
        <div className="main-container">
          <StepperWrapper current={1} />
          <div className="contents">
            <div className="heading-subheading">
              <label className="heading">{t("bookslot.heading")}</label>
              <label className="office-select-label-text sub-heading">
                {t("bookslot.subheading")}
              </label>
            </div>
            {isBanco() ? (
              <div className="bs-banco-servicetype-text">
                {t("banco.bs.text")}
              </div>
            ) : (
              ""
            )}
            <div className="office-wrap">
              <label className="office-select-label-text">
                {customerSlotDetails.isOffice
                  ? t("office.servicetype.label")
                  : t("servicetype.label")}
              </label>
              <Dropdown
                options={sessionServiceTypes}
                onChange={(data) => setSelectedServiceTypes(data.option)}
                value={selectedServiceTypes ? selectedServiceTypes : null}
                placeholder="Selecciona..."
                size="md"
                disabled={
                  sessionServiceTypes && sessionServiceTypes.length === 1
                    ? true
                    : false
                }
              />
            </div>
            <div className="office-wrap">
              <label className="office-select-label-text">
                {" "}
                {t("date.label")}
              </label>
              <CustomDatePicker
                value={pickUpDate}
                onChange={(date) => {
                  setPickUpDate(date);
                }}
                minDate={new Date()}
                disabledDatesList={disableDateList}
                maxDate={lastSlotDate}
              />
            </div>
            <div className="office-wrap">
              <label className="office-select-label-text">
                {" "}
                {t("schedule")}
              </label>
              <Dropdown
                options={dayOptions}
                onChange={(data) => setSelectedSlot(data.option)}
                value={selectedSlot ? selectedSlot : null}
                placeholder="Selecciona..."
              />
            </div>
            {currentDaySlots && currentDaySlots.length > 0 ? (
              !selectedSlot && (
                <label className="select-slot-label">
                  {t("bookslot.pleaseSelectASlot")}
                </label>
              )
            ) : (
              <label className="select-slot-label">
                {t("bookslot.noSlotInServiceType")}
              </label>
            )}
            {getMaxAllowedPeopleCount() === 1 ? (
              ""
            ) : (
              <div className="office-wrap">
                <label className="office-select-label-text">
                  {t("numberofpeople.label")}
                </label>
                <Dropdown
                  options={peopleAllowedList}
                  onChange={(data) => setNumberOfPeople(data.option)}
                  value={numberOfPeople ? numberOfPeople : null}
                  size="md"
                  scrollableHeightinPixel={150}
                />
              </div>
            )}
          </div>
          <div className="footer-div">
            <BlockBtn
              name={t("continue")}
              handleClick={onSlotBooking}
              disabled={!selectedSlot?.value}
            />
          </div>
        </div>
      ) : (
        <div>
          <div className="noSlots-label">
            <label>{getNoSlotText()}</label>
          </div>
          <Button handleClick={handleBackBtn} value={t("back.label")} />
        </div>
      )}
    </div>
  );
};

export default BookSlot;
